import React from "react"
import { Typography } from "@material-ui/core"
import clsx from "clsx"
import useStyles from "@/components/ProductReportClient/styles"
import { formatPhoneNumber } from "@/utils/mask"
import { Link } from "react-router-dom"

export type PhoneNumberRedirectProps = {
	phoneNumber: string
	customizedClass?: string
	customLinkTarget?: string
}

const PhoneNumberRedirect: React.FC<PhoneNumberRedirectProps> = (props) => {
	const { phoneNumber, customizedClass, customLinkTarget } = props
	const classes = useStyles()
	return (
		<>
			{
				<Link to={`/attendance/chat?phone=${phoneNumber}`} target={customLinkTarget || "_blank"} style={{ textDecoration: "none" }}>
					<Typography
						className={`${clsx({
							[classes.contact]: true
						})} ${customizedClass}`}
					>
						{formatPhoneNumber(phoneNumber)}
					</Typography>
				</Link>
			}
		</>
	)
}

export default PhoneNumberRedirect
